export enum Labels {
  FIRST_NAME = 'First Name',
  LAST_NAME = 'Last Name',
  EMAIL = 'Email',
  BUSINESS_NAME = 'Business Name',
  ADDRESS_1 = 'Address 1',
  ADDRESS_2 = 'Address 2',
  PHONE_NUMBER = 'Phone Number',
  COUNTRY = 'Country',
  STATE = 'State',
  CITY = 'City',
  ZIP_CODE = 'Zip Code',
  USER_NAME = 'Username',
  PASSWORD = 'Password',
  NEW_PASSWORD = 'New Password',
  CONFIRM_PASSWORD = 'Confirm Password',
  CONFIRM_NEW_PASSWORD = 'Confirm New Password',
  SELECT_YOUR_OFFICE = 'Select your office',
  SEARCH_FOR_OFFICE = 'Search For Office',
  COURT_ID = 'Court ID',
  DATA_LIBRARY = 'Data Library',
  PID_LIBRARY = 'PID Library',
  GHS_COURT = 'GHS Court',
  GHS_COUNTY = 'GHS County',
  PACE_ACCOUNT_ID = 'Pace Account ID',
  PACE_SUB_ID = 'Pace Sub ID',
  PACE_MERCHANT_ID = 'Pace Merchant ID',
  ONLINE_FORM_NAME = 'Online Form Name',
  COUNTER_FORM_NAME = 'Counter Form Name',
  SERVICE_FEE_DESCRIPTION = 'Service Fee Description',
  SERVICE_FEE_ACCOUNT_SUB_ID = 'Service Fee Account Sub ID',
  SERVICE_FEE_RATE = 'Service Fee Rate',
  GHS_SERVICE_FEE_RATE = 'GHS Service Fee Rate',
  SELECT_ALL = 'Select All',
  VISA = 'Visa',
  MASTER_CARD = 'Master Card',
  DISCOVER = 'Discover',
  AMEX = 'Amex',
  PARTIAL = 'Partial',
  BATCH = 'Batch',
  ACTIVE_MERCHANT = 'Active Merchant',
  TITLE = 'Title',
  CUSTOMER_NAME = 'Customer Name',
  URL = 'URL',
  TYPE = 'Type',
  SELECTED_ITEM_TYPES = 'Selected item types',
  DEVICE_ID = 'Device ID',
  WORKSTATION_NAME = 'Workstation Name',
  DEVICE_TYPE = 'Device Type',
  DESCRIPTION = 'Description',
  DESC1 = 'Desc1 Title',
  DESC2 = 'Desc2 Title',
  DESC3 = 'Desc3 Title',
  DESC4 = 'Desc4 Title',
  DESC5 = 'Desc5 Title',
  NOTIFICATION = 'Notification',
  ITEM_TYPE = 'Item Type',
  AMOUNT = 'Amount',
  DESC = 'Desc',
  CASE_NUMBER = 'Case Number',
  CITATION_NUMBER = 'Citation Number',
  ID = 'Id',
}

export enum Required {
  FIRST_NAME = 'First Name is required.',
  LAST_NAME = 'Last Name is required.',
  EMAIL = 'Email is required.',
  BUSINESS_NAME = 'Business Name is required.',
  ADDRESS_1 = 'Address-1 is required.',
  ADDRESS_2 = 'Address-2 is required.',
  PHONE_NUMBER = 'Phone Number is required.',
  COUNTRY = 'Country is required.',
  STATE = 'State is required.',
  CITY = 'City is required.',
  ZIP_CODE = 'Zip Code is required.',
  USER_NAME = 'Username is required.',
  PASSWORD = 'Password is required.',
  OFFICE = 'Office is required.',
  COURT_ID = 'Court ID is required.',
  DATA_LIBRARY = 'Data Library is required.',
  PID_LIBRARY = 'PID Library is required.',
  GHS_COURT = 'GHS Court is required.',
  GHS_COUNTY = 'GHS County is required.',
  PACE_ACCOUNT_ID = 'Pace Account ID is required.',
  PACE_SUB_ID = 'Pace Sub ID is required.',
  PACE_MERCHANT_ID = 'Pace Merchant ID is required.',
  ONLINE_FORM_NAME = 'Online Form Name is required.',
  COUNTER_FORM_NAME = 'Counter Form Name is required.',
  SERVICE_FEE_DESCRIPTION = 'Service Fee Description is required.',
  SERVICE_FEE_ACCOUNT_SUB_ID = 'Service Fee Account Sub ID is required.',
  SERVICE_FEE_RATE = 'Service Fee Rate is required.',
  GHS_SERVICE_FEE_RATE = 'GHS Service Fee Rate is required.',
  TITLE = 'Title is required.',
  CUSTOMER_NAME = 'Customer Name is required.',
  URL = 'URL is required.',
  TYPE = 'Type is required.',
  DEVICE_ID = 'Device ID is required.',
  WORKSTATION_NAME = 'Workstation Name is required.',
  DEVICE_TYPE = 'Device Type is required.',
  DESCRIPTION = 'Item Description is required.',
  NOTIFICATION = 'Notification is required.',
  PASSWORD_LENGTH = 'Password length must be from 8 to 10 characters.',
  ITEM_TYPE = 'Item type is required.',
  AMOUNT = 'Amount is required.',
  GENERAL = 'This field is required.',
  CASE_NUMBER = 'Case Number is required.',
  CITATION_NUMBER = 'Citation Number is required.',
  ID = 'Id is required.',
}

export enum Buttons {
  CONTINUE = 'Continue',
  EDIT_ITEM_TYPE = 'Edit Item Type',
  CREATE_ITEM_TYPE = 'Create Item Type',
  SELECT_ALL = 'Select All',
  CLEAR_ALL = 'Clear All',
  BACK = 'Back',
  DOWNLOAD = 'Download',
  PRINT = 'Print',
  OK = 'OK',
  REG_NEW_DEVICE = 'Register New Device',
  UPDATE = 'Update',
  CANCEL = 'Cancel',
  REMOVE = 'Remove',
  EDIT = 'Edit',
  DELETE = 'Delete',
  ADD_CUSTOMER = 'Add Customer',
  RESET = 'Reset',
  ADD_USER = 'Add User',
  SIGN_IN = 'Sign In',
  FORGOT_PASSWORD = 'Forgot password',
  SIGN_UP = 'Sign Up',
  SAVE = 'Save',
  ADD_NOTIFICATION = 'Add Notification',
  ACTIVATE_NOTIFICATION = 'Activate Notification/s',
  DEACTIVATE_NOTIFICATION = 'Deactivate Notification/s',
  DELETE_NOTIFICATION = 'Delete Notification/s',
  SEARCH = 'Search',
  MANUAL = 'Manual',
  SWIPE = 'Swipe',
  OKAY = 'Okay',
  SUBMIT = 'Submit',
}
